import LevelFailedSvg from "../object-graphics/LevelFailedSvg";
import RestartLevelButton from "./RestartLevelButton";
import {
  OTHER_DEATH_TYPES,
  PLACEMENT_TYPE_CIABATTA,
  PLACEMENT_TYPE_CIABATTA_BLAST,
  PLACEMENT_TYPE_ENEMY,
  PLACEMENT_TYPE_FIRE,
  PLACEMENT_TYPE_FLYING_ENEMY,
  PLACEMENT_TYPE_ROAMING_ENEMY,
  PLACEMENT_TYPE_WATER,
} from "../../helpers/consts";
import Sprite from "../object-graphics/Sprite";
import { TILES } from "../../helpers/tiles";
import styles from "./PopupMessage.module.css";
import { useKeyPress } from "../../hooks/useKeyPress";

const showDeathType = (deathType) => {
  const paddedContainerStyles = {
    paddingBottom: 12, //Could be from a styled module?
  };
  const paddedCiabattaStyles = {
    paddingBottom: 8,
  };

  switch (deathType) {
    case PLACEMENT_TYPE_FIRE:
      return <Sprite frameCoord={TILES.FIRE1} />;
    case PLACEMENT_TYPE_WATER:
      return <Sprite frameCoord={TILES.WATER1} />;
    case OTHER_DEATH_TYPES.CLOCK:
      return <Sprite frameCoord={TILES.CLOCK} />;
    case PLACEMENT_TYPE_ROAMING_ENEMY:
      return (
        <div style={paddedContainerStyles}>
          <Sprite frameCoord={TILES.ENEMY_ROAMING} size={32} />
        </div>
      );
    case PLACEMENT_TYPE_FLYING_ENEMY:
      return (
        <div style={paddedContainerStyles}>
          <Sprite frameCoord={TILES.ENEMY_FLYING_RIGHT} size={32} />
        </div>
      );
    case PLACEMENT_TYPE_ENEMY:
      return (
        <div style={paddedContainerStyles}>
          <Sprite frameCoord={TILES.ENEMY_RIGHT} size={32} />
        </div>
      );
    case PLACEMENT_TYPE_CIABATTA:
      return (
        <div style={paddedCiabattaStyles}>
          <Sprite frameCoord={TILES.CIABATTA1} size={48} />
        </div>
      );
    case PLACEMENT_TYPE_CIABATTA_BLAST:
      return <Sprite frameCoord={TILES.CIABATTA_BLAST} />;
    default:
      return null;
  }
};

export default function FailedPopupMessage({ level }) {
  useKeyPress("Enter", () => {
    level.restart();
  });
  return (
    <div className={styles.popupContainer}>
      <LevelFailedSvg />
      <div className={styles.deathTypeContainer}>
        {showDeathType(level.heroDeath.deathType)}
      </div>
      <div className={styles.buttonContainer}>
        <RestartLevelButton level={level} />
      </div>
    </div>
  );
}
